
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.761 18.11H.545L6.955.656h2.181l6.41 17.454H13.33L8.113 3.417h-.137L2.761 18.11zm.818-6.818h8.932v1.875H3.58v-1.875zm28.592-1.909c0 1.841-.332 3.432-.997 4.773-.665 1.34-1.577 2.375-2.736 3.102-1.159.727-2.483 1.091-3.971 1.091-1.49 0-2.813-.364-3.972-1.09-1.16-.728-2.071-1.762-2.736-3.103-.665-1.341-.997-2.932-.997-4.773 0-1.84.332-3.432.997-4.773.665-1.34 1.577-2.375 2.736-3.102 1.159-.727 2.483-1.09 3.971-1.09 1.49 0 2.813.363 3.972 1.09 1.16.727 2.071 1.761 2.736 3.102s.997 2.932.997 4.773zm-2.045 0c0-1.511-.253-2.787-.759-3.827-.5-1.04-1.179-1.826-2.037-2.36-.852-.535-1.807-.802-2.863-.802-1.057 0-2.015.267-2.873.802-.852.534-1.53 1.32-2.037 2.36-.5 1.04-.75 2.316-.75 3.827 0 1.511.25 2.787.75 3.827.506 1.04 1.185 1.826 2.037 2.36.858.535 1.816.802 2.872.802 1.057 0 2.012-.267 2.864-.801.858-.534 1.537-1.321 2.037-2.361.506-1.04.759-2.316.759-3.827z","fill":"#000"}})])
          )
        }
      }
    